module.exports = __webpack_public_path__ + "img/tasci-logo.05d0273f.png";